import API from "../API";

export class Quotations
{
    static get_all()
    {
        return API('quotation.list');
    }

    static get(id){
        return API('quotation.get', {id});
    }
}
